import { exportExcel } from "@api/stores/purchaseInvoiceReport/exportExcel/api";
import { exportPDF } from "@api/stores/purchaseInvoiceReport/exportPDF/api";
import { exportSinglePDF } from "@api/stores/purchaseInvoiceReport/exportSinglePDF/api";
import { stats } from "@api/stores/purchaseInvoiceReport/stats/api";
import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  IPurchaseInvoiceReportGetAllParams,
  IPurchaseInvoiceReportResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IPurchaseInvoiceReportResponse>>,
  IPathBaseParam,
  IPaginationParams & IPurchaseInvoiceReportGetAllParams
>("stores.purchaseInvoiceReport");

export const purchaseInvoiceReport = {
  ...getAllApis,
  stats,
  exportPDF,
  exportExcel,
  exportSinglePDF,
};
